import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledContentAreaRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${themeStyles.colors.darkGreys[4].main};
  border-radius: 8px;

  gap: 2em;
  padding: 1.5em 0.75em 0.75em;

  ${themeMedia.desktop`
    margin-bottom: 2em;
    padding: 3em;
    gap: 3em;
  `}

  > div {
    display: flex;
    align-items: center;
    text-align: center;
  }
`

export const StyledRow = styled.div`
  width: 100%;

  flex-direction: column;
  justify-content: space-around;
  gap: 2em;

  ${themeMedia.desktop`
    flex-direction: row;
  `}
`

export const StyledColumn = styled.div`
  flex-direction: column;
  gap: 0.5em;
  color: ${themeStyles.colors.white.main};
  max-width: 240px;
`
